import { Loader } from "@/components/common/Loader";

/** Blocking overlay for a submit the user must wait on. */
export function LoadingOverlay({ message = "Traitement en cours…" }: { message?: string }) {
  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center bg-foreground/50 backdrop-blur-sm"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="rounded-2xl bg-card p-6 text-center shadow-xl">
        <Loader className="mb-4 py-0" />
        <p className="text-lg text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}

/** Inline placeholder while a screen loads its data. */
export function LoadingState({ message = "Chargement…" }: { message?: string }) {
  return (
    <div className="flex min-h-full items-center justify-center py-12">
      <div className="text-center">
        <Loader className="mb-4 py-0" />
        <p className="text-lg text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
